"use strict";

var _regeneratorRuntime = require("/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthProvider = exports.initUserManager = exports.hasCodeInUrl = exports.AuthContext = void 0;

var react_1 = __importStar(require("react"));

var oidc_client_1 = require("oidc-client");

exports.AuthContext = react_1.default.createContext(undefined);

exports.hasCodeInUrl = function (location) {
  var searchParams = new URLSearchParams(location.search);
  var hashParams = new URLSearchParams(location.hash.replace('#', '?'));
  return Boolean(searchParams.get('code') || searchParams.get('id_token') || searchParams.get('session_state') || hashParams.get('code') || hashParams.get('id_token') || hashParams.get('session_state'));
};

exports.initUserManager = function (props) {
  if (props.userManager) return props.userManager;
  var authority = props.authority,
      clientId = props.clientId,
      clientSecret = props.clientSecret,
      redirectUri = props.redirectUri,
      silentRedirectUri = props.silentRedirectUri,
      postLogoutRedirectUri = props.postLogoutRedirectUri,
      responseType = props.responseType,
      scope = props.scope,
      automaticSilentRenew = props.automaticSilentRenew,
      loadUserInfo = props.loadUserInfo,
      popupWindowFeatures = props.popupWindowFeatures,
      popupRedirectUri = props.popupRedirectUri,
      popupWindowTarget = props.popupWindowTarget;
  return new oidc_client_1.UserManager({
    authority: authority,
    client_id: clientId,
    client_secret: clientSecret,
    redirect_uri: redirectUri,
    silent_redirect_uri: silentRedirectUri || redirectUri,
    post_logout_redirect_uri: postLogoutRedirectUri || redirectUri,
    response_type: responseType || 'code',
    scope: scope || 'openid',
    loadUserInfo: loadUserInfo != undefined ? loadUserInfo : true,
    popupWindowFeatures: popupWindowFeatures,
    popup_redirect_uri: popupRedirectUri,
    popupWindowTarget: popupWindowTarget,
    automaticSilentRenew: automaticSilentRenew
  });
};

exports.AuthProvider = function (_a) {
  var children = _a.children,
      _a$autoSignIn = _a.autoSignIn,
      autoSignIn = _a$autoSignIn === void 0 ? true : _a$autoSignIn,
      onBeforeSignIn = _a.onBeforeSignIn,
      onSignIn = _a.onSignIn,
      onSignOut = _a.onSignOut,
      _a$location = _a.location,
      location = _a$location === void 0 ? window.location : _a$location,
      props = __rest(_a, ["children", "autoSignIn", "onBeforeSignIn", "onSignIn", "onSignOut", "location"]);

  var _react_1$useState = react_1.useState(true),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isLoading = _react_1$useState2[0],
      setIsLoading = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(null),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      userData = _react_1$useState4[0],
      setUserData = _react_1$useState4[1];

  var _react_1$useState5 = react_1.useState(exports.initUserManager(props)),
      _react_1$useState6 = _slicedToArray(_react_1$useState5, 1),
      userManager = _react_1$useState6[0];

  var signOutHooks = function signOutHooks() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setUserData(null);
              onSignOut && onSignOut();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  var signInPopupHooks = function signInPopupHooks() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var userFromPopup;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return userManager.signinPopup();

            case 2:
              userFromPopup = _context2.sent;
              setUserData(userFromPopup);
              onSignIn && onSignIn(userFromPopup);
              _context2.next = 7;
              return userManager.signinPopupCallback();

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };

  var isMountedRef = react_1.useRef(true);
  react_1.useEffect(function () {
    return function () {
      isMountedRef.current = false;
    };
  }, []);
  react_1.useEffect(function () {
    var getUser = function getUser() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _user, user;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!exports.hasCodeInUrl(location)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 3;
                return userManager.signinCallback();

              case 3:
                _user = _context3.sent;
                setUserData(_user);
                setIsLoading(false);
                onSignIn && onSignIn(_user);
                return _context3.abrupt("return");

              case 8:
                _context3.next = 10;
                return userManager.getUser();

              case 10:
                user = _context3.sent;

                if ((!user || user.expired) && autoSignIn) {
                  onBeforeSignIn && onBeforeSignIn();
                  userManager.signinRedirect();
                } else if (isMountedRef.current) {
                  setUserData(user);
                  setIsLoading(false);
                }

                return _context3.abrupt("return");

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    };

    getUser();
  }, [location, userManager, autoSignIn, onBeforeSignIn, onSignIn]);
  react_1.useEffect(function () {
    var updateUserData = function updateUserData() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var user;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return userManager.getUser();

              case 2:
                user = _context4.sent;
                isMountedRef.current && setUserData(user);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    };

    userManager.events.addUserLoaded(updateUserData);
    return function () {
      return userManager.events.removeUserLoaded(updateUserData);
    };
  }, [userManager]);
  return react_1.default.createElement(exports.AuthContext.Provider, {
    value: {
      signIn: function signIn(args) {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return userManager.signinRedirect(args);

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));
      },
      signInPopup: function signInPopup() {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return signInPopupHooks();

                case 2:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));
      },
      signOut: function signOut() {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return userManager.removeUser();

                case 2:
                  _context7.next = 4;
                  return signOutHooks();

                case 4:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));
      },
      signOutRedirect: function signOutRedirect(args) {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return userManager.signoutRedirect(args);

                case 2:
                  _context8.next = 4;
                  return signOutHooks();

                case 4:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));
      },
      userManager: userManager,
      userData: userData,
      isLoading: isLoading
    }
  }, children);
};